import type { Card } from "./card";
import { CardStatus } from "./card";

/** Statuses a card can carry without being part of the holder's wallet any more. */
const EXCLUDED_STATUSES = [CardStatus.Expired, CardStatus.Removed, CardStatus.Cancelled];

/**
 * The card the "Ma carte" tab shows. A holder owns a single card, so the first one still in their
 * wallet is the one to display.
 */
export const getWalletCard = (cards: Card[]): Card | undefined =>
  cards.find((card) => !EXCLUDED_STATUSES.includes(card.status));
